import NetworkAlertProvider from "../../../context/NetworkAlertContext";
import IndiceProvider from "../../../context/IndiceContext";
import LanguageProvider from "../../../context/LanguageContext";
import AudienceProvider, { AudienceContext } from "../../../context/AudienceContext";
import ImageEmissoraProvider from "../../../context/ImageEmissoraContext";
import PracaProvider from "../../../context/PracaContext";
import PeriodicityProvider from "../../../context/PeriodicityContext";
import DateTimeAudienceProvider from "../../../context/DateTimeAudienceContext";
import ChannelsProvider from "../../../context/ChannelsContext";
import Loading from '../../components/Loading';

import Sidebar from "../Sidebar/Sidebar";
import DateNavBar from "../DateNavBar/DateNavBar";
import { DivChartEnum, DivMinuteEnum, SelectTypeGridEnum } from "../../../utils/enums";
import ChartProvider from "../../../context/ChartContext";
import { UiContext } from "../../../context/UiContext";
import { useContext } from "react";


const PageRender = (
  {
    setChangePageToChangePassword,
    DivMinute,
    countryID,
    user,
    renderDivMedComp,
    DivChart,
    renderDivMinuteChart,
    selectTypeGrid,
    SelectGrid,
    renderDivTelaMedia,
    renderDivAnalytic,
    getClassSelecGrid,
    sidebar,
    controlNavBar,
    changeSelectDiv,
    getClassSelecGraphButton,
    t,
    loaded }) => {
  const { isMobile, screenHeight, hasShortHeight } = useContext(UiContext);

  return (
    <>
      <Loading show={!loaded} isMobile={isMobile} />

      <div id="divHome" style={{ display: loaded ? "block" : "none" }} data-testid="divHome">

        <NetworkAlertProvider>
          <IndiceProvider>
            <LanguageProvider>
              <AudienceProvider>
                <ChartProvider>

                  <ImageEmissoraProvider>
                    <PracaProvider>
                      <PeriodicityProvider>
                        <DateTimeAudienceProvider>
                          <ChannelsProvider>
                            <Sidebar
                              stateChangePageToChangePassword={setChangePageToChangePassword}
                              DivMinute={DivMinute}
                              DivChart={DivChart}
                              CountryId={countryID}
                              changeSelectDiv={changeSelectDiv}
                              selectTypeGrid={selectTypeGrid}
                            />
                            <div className="divGrid" id="divGrid">
                              {renderDivMedComp(DivChart, DivMinute, hasShortHeight)}
                              <DateNavBar user={user} />
                              {renderDivMinuteChart(selectTypeGrid, SelectGrid, changeSelectDiv, DivMinute, DivChart, hasShortHeight)}
                              {renderDivTelaMedia(
                                DivMinute,
                                selectTypeGrid,
                                SelectGrid,
                                DivChart
                              )}
                              {renderDivAnalytic(
                                DivMinute,
                                selectTypeGrid,
                                SelectGrid
                              )}
                              <nav
                                id="selecGrid"
                                className={getClassSelecGrid(sidebar)}
                              >
                                <div>
                                  <header>
                                    <button
                                      className="btn_img_selec"
                                      onClick={() => controlNavBar("")}
                                    >
                                      {!isMobile ? (
                                        <img
                                          className="img_selec"
                                          alt="Grid"
                                          src={require("../../../assets/custom/icons/icon_big_split_desktop.png")}
                                        />
                                      ) : (
                                        <img
                                          className="img_selec"
                                          alt="Grid"
                                          src={require("../../../assets/custom/icons/icon_big_split_mobile.png")}
                                        />
                                      )}
                                    </button>
                                    <div className="div_selec_graph">
                                      {hasShortHeight === false && (
                                        <>
                                          <button
                                            className={getClassSelecGraphButton(
                                              DivChart,
                                              DivChartEnum.Chart
                                            )}
                                            onClick={() => changeSelectDiv("C", DivChartEnum.Chart)}
                                          >
                                            <span className={`icon-chart ${getClassSelecGraphButton(DivChart, DivChartEnum.Chart) === 'btn_selec_on' ? 'icon-white' : 'icon-primary'} icon-lg`}></span>
                                            <span className="span_selec">
                                              {" "}
                                              {t("chart.onButton")}
                                            </span>
                                          </button>
                                          <button
                                            className={getClassSelecGraphButton(
                                              DivChart,
                                              DivChartEnum.MedComp
                                            )}
                                            onClick={() => changeSelectDiv("C", DivChartEnum.MedComp)}
                                          >
                                            <span className={`icon-compare-averages ${getClassSelecGraphButton(DivChart, DivChartEnum.MedComp) === 'btn_selec_on' ? 'icon-white' : 'icon-primary'} icon-lg`}></span>

                                            <span
                                              className="span_selec"
                                              style={{ fontSize: "9px" }}
                                            >
                                              {t("secret.rows.secondTable")}
                                            </span>
                                          </button>
                                        </>
                                      )}
                                      <button
                                        className={getClassSelecGraphButton(
                                          DivChart,
                                          DivChartEnum.Empty
                                        )}
                                        onClick={() => changeSelectDiv("C", DivChartEnum.Empty)}
                                      >
                                        <span className={`icon-empty ${getClassSelecGraphButton(DivChart, DivChartEnum.Empty) === 'btn_selec_on' ? 'icon-white' : 'icon-primary'} icon-lg`}></span>
                                        <span className="span_selec">
                                          {" "}
                                          {t("chart.offButton")}
                                        </span>
                                      </button>
                                    </div>
                                    <div className="div_selec_grid">
                                      <button
                                        className={getClassSelecGraphButton(
                                          DivMinute,
                                          DivMinuteEnum.Minute
                                        )}
                                        onClick={() => changeSelectDiv("M", DivMinuteEnum.Minute)}
                                      >
                                        <span className={`icon-minutes ${getClassSelecGraphButton(DivMinute, DivMinuteEnum.Minute) === 'btn_selec_on' ? 'icon-white' : 'icon-primary'} icon-lg`}></span>
                                        <span className="span_selec">
                                          {" "}
                                          {t("secret.rows.unmergeRows")}
                                        </span>
                                      </button>
                                      <button
                                        className={getClassSelecGraphButton(
                                          DivMinute,
                                          DivMinuteEnum.Media
                                        )}
                                        onClick={() => changeSelectDiv("M", DivMinuteEnum.Media)}
                                      >
                                        <span className={`icon-average ${getClassSelecGraphButton(DivMinute, DivMinuteEnum.Media) === 'btn_selec_on' ? 'icon-white' : 'icon-primary'} icon-lg`}></span>

                                        <span className="span_selec">
                                          {" "}
                                          {t("secret.rows.mergeRows")}
                                        </span>
                                      </button>
                                      {!isMobile && (
                                        <button
                                          className={getClassSelecGraphButton(
                                            DivMinute,
                                            4
                                          )}
                                          onClick={() => {
                                            changeSelectDiv("M", SelectTypeGridEnum.Analytic)
                                          }}
                                        >
                                          <span className={`icon-analytics ${getClassSelecGraphButton(DivMinute, 4) === 'btn_selec_on' ? 'icon-white' : 'icon-primary'} icon-lg`}></span>
                                          <span className="span_selec">
                                            {" "}
                                            {t("secret.rows.audcharts")}
                                          </span>
                                        </button>
                                      )}
                                    </div>
                                  </header>
                                </div>
                              </nav>
                            </div>
                          </ChannelsProvider>
                        </DateTimeAudienceProvider>
                      </PeriodicityProvider>
                    </PracaProvider>
                  </ImageEmissoraProvider>
                </ChartProvider>
              </AudienceProvider>
            </LanguageProvider>
          </IndiceProvider>
        </NetworkAlertProvider>
        <button
          id="blurPanel"
          onClick={() => controlNavBar("")}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            zIndex: "1",
            backgroundColor: "rgb(0, 0, 0)",
            opacity: "0.7",
            display: "none",
            border: "none",
            padding: "0",
          }}
        ></button>
      </div>
    </>
  );

};
export default PageRender;